import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Text from '../Text/Text'
import styles from './checkboxField.module.scss'

const CheckboxField = (props) => {
  const {
    field: { name = '', id, value },
    form: { touched = {}, errors = {}, setFieldValue },
    label
  } = props

  const checkboxFieldClass = classNames(styles.check, {
    [styles.checked]: value
  })

  return (
    <div className={styles.field}>
      <label htmlFor={id}>
        <Text size="xxxs" color="gray" value={label} />

        <div className={checkboxFieldClass} />

        <input
          type="checkbox"
          id={id}
          name={name}
          onChange={() => setFieldValue(name, !value)}
          checked={value}
          className={styles.input}
        />
      </label>

      {touched[name] && errors[name] && (
        <div className="error">{errors[name]}</div>
      )}
    </div>
  )
}

CheckboxField.defaultProps = {
  field: undefined,
  form: undefined,
  label: null
}

CheckboxField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func
  }),
  label: PropTypes.string
}

export default CheckboxField
